import React                 from 'react';
import ReactDOM              from 'react-dom';
import { Provider }          from 'react-redux';
import registerServiceWorker from './registerServiceWorker';
import  jwtPayloadDecoder    from 'jwt-payload-decoder';
import { setCurrentUser,
         checkSessao }       from './actions/authenticActions';
import requireAuth           from './utils/requireAuthenticate'; 
import index                 from './components/index';
import LoginForm             from './components/login/login';
import { BrowserRouter as Router, Route }   from 'react-router-dom';
import { PersistGate }       from 'redux-persist/integration/react';    
import { store, persistor }  from './utils/store';
import { Config } from './actions/configActions';    

if (localStorage.getItem("jwtToken")){
    store.dispatch(checkSessao())
    const payload = (jwtPayloadDecoder.getPayload(localStorage.getItem("jwtToken")))
    store.dispatch(setCurrentUser(
    payload,
    JSON.parse(localStorage.getItem("session")),
    JSON.parse(localStorage.getItem("pontuacao"))
   ));
}

ReactDOM.render(
                <Provider store={store}>
                  <PersistGate loading={null} persistor={persistor}>
                   <div>
                    <Router basename={`${Config().raiz}`}>
                      <div>
                        <Route exact path="/" component={LoginForm}/>
                        <Route path="/home" component={requireAuth(index)}/>
                        <Route path="/login" component={LoginForm}/>
                      </div>
                    </Router>
                    </div>
                    </PersistGate>
                </Provider>
                ,document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js